import { setSearch, SetSearchAction, similaritySearch, SimilaritySearchAction } from '../../redux/actions/analytics';
import { EventCategory, EventDefinition, EventsMap, SearchEvent } from '../types';

const trackSearch: EventDefinition<SetSearchAction> = (action) => ({
  category: EventCategory.Search,
  event: SearchEvent.Search,
  action: 'set-search-state',
  label: JSON.stringify(action),
});

const trackSimilaritySearch: EventDefinition<SimilaritySearchAction> = (action) => ({
  category: EventCategory.Search,
  event: SearchEvent.SimilaritySearch,
  action: 'click',
  track_id: action.payload.trackId,
  action_source: action.payload.actionSource,
});

export const searchEventsMap: EventsMap = {
  [setSearch.type]: trackSearch,
  [similaritySearch.type]: trackSimilaritySearch,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/search.ts